import { CardActionArea, styled } from '@mui/material';
import type { StorageUnit } from 'store/storageunits/types';
import { FolderTitle } from './styles';
import { splitName } from 'util/nameHelper';
import { useStorageUnits } from 'contexts/storageUnitContext';
import Card, { WIDTH } from './Card';
import MoreButton from './MoreButton';
import { isReadOnlyFolder } from 'util/access';
import { useIsProject } from 'hooks/useIsProject';
import { getStorageUnitIcon } from 'util/getStorageUnitIcon';
import { isShared } from 'util/isSharedHelper';
import { ReactComponent as SharedIcon } from 'icons/shared.svg';

type Props = {
  storageUnit: StorageUnit;
};

const HEIGHT = 48;

const CardWrapper = styled(Card)`
  width: ${WIDTH}px;
  height: ${HEIGHT}px;
`;

const Container = styled(CardActionArea)`
  display: grid;
  grid-template-columns: 24px auto 24px 24px;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(1)};
  height: 100%;
  justify-content: initial;
  &[data-readonly='true'] {
    color: ${({ theme }) => theme.vars.palette.grey[600]};
  }
`;

const StyledSharedIcon = styled(SharedIcon)`
  height: 24px;
  width: 24px;
  color: ${({ theme }) => theme.vars.palette.grey[800]};
`;

const Folder = ({ storageUnit }: Props) => {
  const { id, type, name, archived } = storageUnit;
  const { openFolder } = useStorageUnits();
  const isProject = useIsProject();

  const isReadOnly = isReadOnlyFolder(storageUnit);

  const handleFolderClicked = () => {
    if (archived) {
      return;
    }
    openFolder(id);
  };

  return (
    <CardWrapper storageUnit={storageUnit} isDisabled={isReadOnly}>
      <Container
        onClick={handleFolderClicked}
        data-readonly={isReadOnly ? 'true' : undefined}
      >
        {getStorageUnitIcon(storageUnit, isProject)}
        <FolderTitle>{splitName(type, name)}</FolderTitle>
        {isShared(storageUnit.access) ? <StyledSharedIcon /> : <div />}
        <MoreButton unit={storageUnit} disabled={isReadOnly} />
      </Container>
    </CardWrapper>
  );
};

export default Folder;
